package presentation.screens.business.onboard.create_business_screen.component

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import component.input.TextInputField
import feature.business.viewModel.BusinessViewModel

@Composable
fun CreateBusinessAddress(viewModel: BusinessViewModel) {
    Column(modifier = Modifier.fillMaxWidth().wrapContentHeight().padding(8.dp)) {
        TextInputField("Enter Pin code") {
            try {
                viewModel.createBusiness.value.Address?.ZipCode = it.toInt()
            } catch (_: Throwable) {

            }
        }
        TextInputField("Enter City") {
            viewModel.createBusiness.value.Address?.City = it
        }

        TextInputField("State") {
            viewModel.createBusiness.value.Address?.State = it
        }
        TextInputField("Locality/Area/Street") {
            viewModel.createBusiness.value.Address?.Area = it
        }
        TextInputField("Flat Number/ Building Name") {
            viewModel.createBusiness.value.Address?.House = it
        }
        TextInputField("Landmark") {
            viewModel.createBusiness.value.Address?.LandMark = it
        }
    }
}